<template>
  <div>
    <v-row v-if="loading">
      <v-col>
        <v-progress-circular indeterminate />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card
          flat
          class="px-4 py-3"
          height="100%"
          :key="reRender"
          :class="!isEditCard1 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{
                      $t("user.profile.companyProfile.vatNumber")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.vat"
                      :isEdit="isEditCard1"
                      ref="vat"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{
                      $t("user.profile.companyProfile.vatPercentage")
                    }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.vatPercentage"
                      :isEdit="isEditCard1"
                      :validateRules="'double'"
                      ref="vatPercentage"
                    />
                  </v-col>
                </v-row>
                <!-- <v-divider class="my-3"></v-divider> -->
              </v-col>
            </v-row>
          </div>
          <float-btn
            v-if="!loading"
            :isEdit="isEditCard1"
            @save="saveCard1Items"
            @edit="isEditCard1 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData1"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="
            snackbarError = false;
            snackbarErrorMessage = null;
          "
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Editable2 from "../../../core-module/components/ContentEditable2.vue";
import FloatBtn from "../employee-profile/FloatBtn.vue";

import { createOrUpdateSubscriberProfile } from "../../methods/createOrUpdateSubscriberProfile";

export default {
  components: {
    Editable2,
    FloatBtn,
  },
  props: {
    companyData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      snackbarError: false,
      snackbarErrorMessage: null,
      card1: {
        vat: "",
        vatPercentage: "",
      },
      companyProfile: null,
      savingData1: false,
      isEditCard1: false,
      reRender: 0,
      card1Error: {
        vatErr: null,
        percentageErr: null,
      },
    };
  },

  watch: {
    companyData: {
      immediate: true,
      handler() {
        this.companyProfile = this.companyData ? this.companyData : null;
        this.resetFormData();
      },
      deep: true,
    },
  },
  methods: {
    resetCard1Error() {
      this.card1Error = {
        vatErr: null,
        percentageErr: null,
      };
    },
    resetFormData() {
      this.card1.vat = this.companyProfile?.vatDetails?.vat;
      this.card1.vatPercentage =
        this.companyProfile?.vatDetails?.vatPercentage.toString();

      this.reRender++;
    },

    async saveCard1Items() {
      this.resetCard1Error();
      this.snackbarErrorMessage = null;
      this.card1Error.vatErr = (await this.$refs.vat.checkIsValid())
        ? null
        : true;
      this.card1Error.percentageErr =
        (await this.$refs.vatPercentage.checkIsValid()) ? null : true;
      if (Object.values(this.card1Error).some(x => x != null)) {
        return;
      }

      this.savingData1 = true;
      this.isEditCard1 = false;
      let saveData = {
        vatDetails: {
          vat: this.card1.vat ? this.card1.vat : null,
          vatPercentage: this.card1.vatPercentage
            ? parseFloat(this.card1.vatPercentage)
            : null,
        },
      };

      this.createOrUpdateProfile(saveData).then(response => {
        if (response.error) {
          this.$emit("onError");
          this.resetFormData();
        }

        this.savingData1 = false;
      });
    },

    createOrUpdateProfile(data) {
      return createOrUpdateSubscriberProfile(data);
    },
  },
};
</script>

<style scoped>
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
</style>
